import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'

type Mode = 'CREATE' | 'EDIT'

type SetSuporteModal = {
  name: string,
  value: boolean,
}

type SuporteModal = {
  salaRobotica: boolean,
}

interface SalaRobotica {
  id: string,
  descricao: string,
  status: string,
  hospitalId: string,
}

@Module({ namespaced: true, name: 'SuporteSalasRoboticasStore' })
export default class SuporteSalasRoboticasStore extends VuexModule {
  public hospitalId: string = ''
  public mode: Mode = 'CREATE'

  public modal: SuporteModal = {
    salaRobotica: false,
  }

  @Mutation
  setModal(modal: SetSuporteModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Mutation
  setMode(param: any) {
    this.mode = param.mode
  }

  private salasRoboticasDefault: SalaRobotica[] = []
  public salasRoboticas: SalaRobotica[] = [...this.salasRoboticasDefault]

  private salaRoboticaDefault: SalaRobotica = {
    id: '',
    descricao: '',
    status: 'Ativo',
    hospitalId: '',
  }

  public salaRobotica: SalaRobotica = { ...this.salaRoboticaDefault }

  @Mutation
  setSalasRoboticas(value: SalaRobotica[]) {
    this.salasRoboticas = value
  }

  @Mutation
  clearSalasRoboticas() {
    this.salasRoboticas = [...this.salasRoboticasDefault]
  }

  @Mutation
  setSalaRobotica(value: SalaRobotica) {
    this.salaRobotica = value
  }

  @Mutation
  clearSalaRobotica() {
    this.salaRobotica = { ...this.salaRoboticaDefault }
  }

  @Mutation
  updateSalaRoboticaInList(value: SalaRobotica) {
    const index = this.salasRoboticas.findIndex((e: SalaRobotica) => e.id === value.id)
    if (index !== -1) this.salasRoboticas[index] = { ...value }
  }

  @Mutation
  insertSalaRobotica(value: SalaRobotica) {
    this.salasRoboticas.push({ ...value })
  }

  @Action
  async getSalasRoboticas() {
    try {
      const request = await Apis.Agendamento.SuporteApi.getSalasRoboticasByHospital(this.hospitalId)
      if (request.success) {
        this.context.commit('setSalasRoboticas', request.data.salaRobotica as SalaRobotica[])
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertSalaRobotica() {
    const params: any = { ...this.salaRobotica }
    params.hospitalId = this.hospitalId

    if (params.status === 'Inativo') params.status = 'Removido'
    if (this.mode === 'CREATE') delete params.id

    const request = await Apis.Agendamento.SuporteApi.upsertSalaRobotica(params)
    return request
  }
}
